import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { useEffect, useState } from "react";
import { UserRole, UserTransport } from "src/app/transports/user";

const useProjectManagersOptions = (asAdmin = false, inicialRequest = true) => {
    const [projectManagersOptions, setProjectManagersOptionsLoading] = useState<
        Array<SimpleFormSelectOption>
    >([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const roles = [
        UserRole.ROLE_PROJECT_MANAGER.toString(),
        UserRole.ROLE_LEAD_PROJECT_MANAGER.toString(),
    ];
    if (asAdmin) roles.push(UserRole.ROLE_ADMIN);

    const fetch = () => {
        setLoading(true);
        UserTransport.listByRoles({
            roles,
            isActive: 1,
        })
            .then((res) => {
                setProjectManagersOptionsLoading(
                    res.map((el: any) => ({
                        label: `${el.firstName} ${el.lastName}`,
                        value: el.id,
                    }))
                );
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };
    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (inicialRequest) fetch();
    }, []);

    return { projectManagersOptions, refresh, loading, error };
};

export default useProjectManagersOptions;
